import styled, { css } from 'styled-components';

export const UserEditablePopupContainer = styled.div`
  width: 350px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  text-align: center;
  background: rgb(39, 47, 60);

  & > div {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0px;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;

      & > select:disabled {
        background: #333;
      }

      & > p {
        margin-bottom: 0.3rem;
        width: 70px;
        text-align: left;
      }

      & > input,
      & > select {
        width: 180px;
        font-size: 13px;
      }

      & > input:read-only {
        background-color: #969696;
        border: 0px;
        cursor: initial;
      }

      & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 180px;

        & > select {
          width: 100%;
        }
      }
    }

    & > div.error-box {
      font-size: 10px;
    }
  }

  & > button {
    color: #fff;
    font-size: 14px;
    background-color: #3d4a5c;
    border-width: 0px;
    padding: 0.4rem 2.4rem;

    ${(props) =>
      props.checker
        ? css`
            display: block;
          `
        : css`
            display: none;
          `}
  }
`;
